import {
  FETCH_ALL_USERS,
  FETCH_ALL_USERS_SUCCESS,
  FETCH_ALL_USERS_FAILED,

  EDIT_USER,
  EDIT_USER_SUCCESS,
  EDIT_USER_FAILED,


  FETCH_ALL_ADMINS_START,
  FETCH_ALL_ADMINS_SUCCESS,
  FETCH_ALL_ADMINS_FAILED,

  CLEAR_USER_ERROR,

} from "../store/types";

export const INITIAL_STATE = {
  users: null,
  currentUser: null,
  admins: [],
  loading: false,
  error: {
    flag: false,
    msg: null
  }
}

export const usersreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_ALL_USERS:
      return {
        ...state,
        loading: true
      };
    case FETCH_ALL_USERS_SUCCESS:
      return {
        ...state,
        users: action.payload,
        loading: false
      };
    case FETCH_ALL_USERS_FAILED:
      return {
        ...state,
        users: null,
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };

    case EDIT_USER:
      return {
        ...state,
        loading: true
      };
    case EDIT_USER_SUCCESS:
      return {
        ...state,
        currentUser: action.payload,
        loading: false
      };
    case EDIT_USER_FAILED:
      return {
        ...state,
        users: null,
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };

    case FETCH_ALL_ADMINS_START:
      return {
        ...state,
        loading: true
      };
    case FETCH_ALL_ADMINS_SUCCESS:
      return {
        ...state,
        admins: action.payload,
        loading: false
      };
    case FETCH_ALL_ADMINS_FAILED:
      return {
        ...state,
        admins: null,
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    case CLEAR_USER_ERROR:
      return {
        ...state,
        currentUser: null,
        loading: false,
        error: {
          flag: false,
          msg: null,
        },
      };

    default:
      return state;
  }
};